import styled from "styled-components";

const StyledDiv = styled.div`
  &&& {
    width: 100%;
    height: 100%;
    position: relative;

    dl {
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
    }

    dd {
      font-size: 34px;
    }

    .v_flfr {
      bottom: 225px;
    }

    .v_rlrr {
      bottom: 60px;
    }
  }
`;

const VarianceDiv = ({ className, children }) => {
  return <StyledDiv className={className}>{children}</StyledDiv>;
};

export default VarianceDiv;
